import React, { useCallback, useState } from 'react';
import { Popover, MenuItem, Button, Typography, Box } from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import dashboardStore from 'store/dashboardStore';

const EventFilter = ({ onMenuChange, queryParams }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openPopover = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closePopover = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleRangeSelect = menu => {
    onMenuChange(menu);
    closePopover();
  };

  return (
    <Box>
      <Button
        onClick={openPopover}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          textTransform: 'none',
          display: 'flex',
          alignItems: 'center',
          height: '36px',
        }}>
        <Typography variant="body2" sx={{ mr: 0 }}>
          Wine List{' '}
          <b>{dashboardStore.menus.find(menu => +menu.id === +queryParams.params.selectedMenuId)?.menuName}</b>
        </Typography>
      </Button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Box>
          {dashboardStore.menus.map(menu => (
            <MenuItem key={menu.id} onClick={() => handleRangeSelect(menu)}>
              {menu.menuName}
            </MenuItem>
          ))}
        </Box>
      </Popover>
    </Box>
  );
};

EventFilter.propTypes = {
  onMenuChange: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
};

export default EventFilter;
